/*
 * @Author: Teemo Ding
 * @Date: 2021-09-22 11:27:07
 * @LastEditTime: 2021-10-13 15:53:04
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/request/settings/logistics/deliveryMethod.ts
 */
import { get, post, remove } from 'src/tools/server';

export const getDeliveryMethodList = (warehouseUuid, params?) =>
  get<any>(
    `/portal/setting/store/logistics/deliveryMethods/${warehouseUuid}`,
    params || {},
  );

export const saveDeliveryMethod = (data) =>
  post<any>(`/portal/setting/store/logistics/deliveryMethod`, data || {}, {});

export const getDeliveryMethod = (uuid) =>
  get<any>(`/portal/setting/store/logistics/deliveryMethod/${uuid}`, {});

export const deleteDeliveryMethod = (uuid) =>
  remove<any>(`/portal/setting/store/logistics/deliveryMethod/${uuid}`, {});
